(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faqQuestion').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.closest('.faqItem');
    item.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faqQuestion').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.closest('.faqItem');
    item.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["find-solution-layout"] && !Shopify.designMode) return;
  try {
    
(function () {
  const PRODUCTS = {
    probiotic: {
      title: "Probiotic Protection",
      img: "https://probiotic-airusa.com/cdn/shop/files/BioLogic-Mini.webp?v=1764790582&width=3840",
      url: "/products/probiotic-protection-effective-for-areas-up-to-300-square-feet",
      desc: "A compact option for everyday indoor protection in smaller spaces."
    },
    bapf18: {
      title: "EnviroBiotics® BAPF-18",
      img: "https://probiotic-airusa.com/cdn/shop/files/BAPF18.webp?v=1767049863&width=3840",
      url: "/products/envirobiotics®-bapf-18-rechargeable-battery-operated-fogger-up-to-6-000-sq-ft",
      desc: "Targeted probiotic fogger for high-need areas."
    },
    biotica800: {
      title: "The Biotica 800",
      img: "https://probiotic-airusa.com/cdn/shop/files/biotica-800.webp?v=1764790797&width=3840",
      url: "/products/the-biotica-800™-a-healthier-home-for-the-entire-family",
      desc: "Great for shared living areas and medium-to-large spaces."
    },
    ba2080: {
      title: "The BA 2080",
      img: "https://probiotic-airusa.com/cdn/shop/files/BA2080.webp?v=1764790917&width=3840",
      url: "/products/the-ba-2080™-the-perfect-blend-of-hepa-and-probiotic-power",
      desc: "A higher capacity device for larger homes."
    },
    ebioticpro: {
      title: "E-Biotic Pro",
      img: "https://probiotic-airusa.com/cdn/shop/files/E-BioticPro-square.jpg?v=1764794286&width=3840",
      url: "/products/e-biotic-pro-the-definitive-commercial-whole-home-system",
      desc: "Designed for whole-home and commercial-scale protection."
    }
  };

  const SIZE_BASE = {
    "Single room (up to 300 sq. ft.)": ["probiotic", "bapf18"],
    "Multiple rooms (300–800 sq. ft.)": ["biotica800", "bapf18"],
    "Large home (1,200–2,600 sq. ft.)": ["ba2080", "ebioticpro", "bapf18"],
    "Whole home / commercial space": ["ebioticpro", "bapf18"]
  };

  const BOOSTS = {
    pets: {
      "No pets": ["bapf18"],
      "Dogs": ["biotica800", "bapf18"],
      "Cats": ["biotica800", "bapf18"],
      "Dogs and cats": ["biotica800", "ba2080", "ebioticpro", "bapf18"]
    },
    allergies: {
      "No": ["biotica800", "bapf18"],
      "Seasonal allergies": ["bapf18"],
      "Asthma or chronic sensitivities": ["biotica800", "ba2080", "ebioticpro", "bapf18"]
    },
    env: {
      "Desert / dry climate": ["bapf18"],
      "Beach or coastal area": ["bapf18"],
      "City / urban": ["bapf18"],
      "Suburban": ["bapf18"],
      "Rural": ["bapf18"]
    }
  };

  const SIZE_EXCLUDE = {
    "Single room (up to 300 sq. ft.)": [],
    "Multiple rooms (300–800 sq. ft.)": ["probiotic"],
    "Large home (1,200–2,600 sq. ft.)": ["probiotic", "biotica800"],
    "Whole home / commercial space": ["probiotic", "biotica800", "ba2080"]
  };

  const sizeEl = document.getElementById("fs_size");
  const petsEl = document.getElementById("fs_pets");
  const allergiesEl = document.getElementById("fs_allergies");
  const envEl = document.getElementById("fs_env");
  const btn = document.getElementById("fs_submit");
  const error = document.getElementById("fs_error");
  const results = document.getElementById("fs_results");
  const resultsHeader = document.getElementById("fs_resultsHeader");
  const cards = document.getElementById("fs_cards");

  function unique(arr) {
    return Array.from(new Set(arr));
  }

  function applyExclusions(list, size) {
    const excluded = new Set(SIZE_EXCLUDE[size] || []);
    return list.filter((k) => !excluded.has(k));
  }

  btn.addEventListener("click", function (e) {
    e.preventDefault();

    const size = sizeEl.value;
    const pets = petsEl.value;
    const allergies = allergiesEl.value;
    const env = envEl.value;

    if (!size || !pets || !allergies || !env) {
      error.classList.add("active");
      results.classList.remove("active");
      return;
    }

    error.classList.remove("active");

    const combinedRaw = unique([
      ...(SIZE_BASE[size] || []),
      ...(BOOSTS.pets[pets] || []),
      ...(BOOSTS.allergies[allergies] || []),
      ...(BOOSTS.env[env] || [])
    ]);

    const combined = applyExclusions(combinedRaw, size);

    resultsHeader.textContent =
      `Recommended Solutions: ${size} – ${pets} – ${allergies} – ${env}`;

    cards.innerHTML = "";

    combined.forEach((key) => {
      const p = PRODUCTS[key];
      if (!p) return;

      const card = document.createElement("div");
      card.className = "find-solution__card";
      card.innerHTML = `
        <div class="find-solution__cardTitle">${p.title}</div>
        <img class="find-solution__cardImg" src="${p.img}" alt="${p.title}">
        <div class="find-solution__cardDesc">${p.desc}</div>
        <a class="find-solution__cardLink" href="${p.url}">View product →</a>
      `;
      cards.appendChild(card);
    });

    results.classList.add("active");
    results.scrollIntoView({ behavior: "smooth", block: "start" });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-clean"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.itMobile[data-animate="true"]');
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  sections.forEach(section => observer.observe(section));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-right-clean"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.itRight[data-animate="true"]');
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  sections.forEach(section => observer.observe(section));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
